import React, { useEffect, useRef } from "react";

export default function CardSection({
  heading,
  subtitle,
  cardData = [],
  onCtaClick,
}) {
  // holds one ref per card
  const cardsRef = useRef([]);

  useEffect(() => {
    const cards = cardsRef.current.filter(Boolean);
    const cleanups = [];

    cards.forEach((card) => {
      const onMove = (e) => {
        const r = card.getBoundingClientRect();
        const x = e.clientX - r.left;
        const y = e.clientY - r.top;
        card.style.setProperty("--mx", `${x}px`);
        card.style.setProperty("--my", `${y}px`);
        card.style.setProperty("--mo", "1");
      };
      const onLeave = () => {
        card.style.setProperty("--mo", "0");
      };

      card.addEventListener("pointermove", onMove);
      card.addEventListener("pointerleave", onLeave);
      cleanups.push(() => {
        card.removeEventListener("pointermove", onMove);
        card.removeEventListener("pointerleave", onLeave);
      });
    });

    return () => cleanups.forEach((fn) => fn());
  }, [cardData]);

  return (
    <main className="main flow">
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
        <h1 className="main__heading" style={{ fontWeight: "800" }}>{heading}</h1>
        {subtitle && (
          <div className="text-center mb-6 text-gray-400">{subtitle}</div>
        )}
      </div>

      <div className="cards__inner">
        {cardData.map((c, i) => (
          <div
            key={i}
            ref={(el) => (cardsRef.current[i] = el)}
            className="card"
            style={{ "--hue": c.hue, position: "relative" }}
          >
            {/* Inline loading overlay when card is busy */}
            {c.loading && (
              <div style={{
                position: "absolute", inset: 0, zIndex: 20,
                background: "rgba(0,0,0,0.75)", backdropFilter: "blur(4px)",
                borderRadius: "inherit", display: "flex", flexDirection: "column",
                alignItems: "center", justifyContent: "center", gap: "12px",
              }}>
                {/* Spinning ring */}
                <div style={{ position: "relative", width: 56, height: 56 }}>
                  <svg style={{ animation: "spin 1.2s linear infinite", width: 56, height: 56 }} viewBox="0 0 56 56" fill="none">
                    <circle cx="28" cy="28" r="22" stroke="rgba(255,255,255,0.1)" strokeWidth="4"/>
                    <path d="M28 6 A22 22 0 0 1 50 28" stroke={`hsl(${c.hue},82%,60%)`} strokeWidth="4" strokeLinecap="round"/>
                  </svg>
                  <span style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
                    {c.loadingIcon || "⚡"}
                  </span>
                </div>
                <p style={{ color: "#fff", fontWeight: 700, fontSize: 13, textAlign: "center", padding: "0 12px" }}>
                  {c.loadingText || "Generating…"}
                </p>
                {c.loadingSubtext && (
                  <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 11, textAlign: "center", padding: "0 16px" }}>
                    {c.loadingSubtext}
                  </p>
                )}
              </div>
            )}

            <h3 className="card__heading">{c.heading}</h3>
            {c.price && <p className="card__price">{c.price}</p>}
            {c.description && <div className="card__desc text-base font-semibold">{c.description}</div>}
            {c.extra && <div className="card__extra">{c.extra}</div>}
            {c.bullets && (
              <ul className="card__bullets flow">
                {c.bullets.map((b, j) => (
                  <li key={j}>{b}</li>
                ))}
              </ul>
            )}
            <button
              type="button"
              className="cta disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={c.ctaDisabled}
              onClick={() => onCtaClick?.(c.ctaAction)}
            >
              {c.cta}
            </button>
          </div>
        ))}
      </div>
    </main>
  );
}
